import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { Sync } from 'modules/integrations_silae_api/lib/IncidenceSync/store'
import fieldTranslations from 'modules/integrations_silae_api/lib/fieldTranslations'

const Unavailable = ({ sync }: { sync: Sync }) => {
  return (
    <>
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.silae_api.personal_data.unavailable.title')}
      </Text.Header2>
      <Box>
        {i18n.t('payroll_integrations.incidences.silae_api.personal_data.unavailable.message')}
      </Box>
      <Box component="ul" paddingX="s8">
        {(sync.unavailable_fields as string[]).map((field) => (
          <Box component="li" key={field}>
            {fieldTranslations.t(field)}
          </Box>
        ))}
      </Box>
    </>
  )
}

export default Unavailable
